import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { homebaseBaseUrl } from '@/utils/homebaseLink';

import { BillingReportRow } from '../../types';
import { isBlank } from '../../utils/isBlank';

const ServiceTypeGridCell = ({ data }: { data?: BillingReportRow }): JSX.Element | null => {
  const { host } = useContext(AppContext);
  if (!data || isBlank(data.service_type)) {
    return null;
  }

  let url = '';
  const serviceClass = data.service_class;
  const serviceId = data.service_id;
  const appointmentId = data.appointment_id;

  if (serviceClass === 'Appointment') {
    url = `${homebaseBaseUrl(host)}/appointments/${appointmentId}/`;
  } else if (serviceClass === 'Drug Screen') {
    url = `${homebaseBaseUrl(host)}/drug_screens/${serviceId}/`;
  } else if (serviceClass === 'Chart') {
    url = `${homebaseBaseUrl(host)}/agent/forms/${serviceId}/`;
  }

  return (
    <a href={url} target="_blank" rel="noreferrer" className="text-blue-600 hover:text-blue-800">
      {data.service_type}
      <FontAwesomeIcon icon={faExternalLink} className="ml-1 text-xs" />
    </a>
  );
};

export default ServiceTypeGridCell;
